module.exports = __webpack_public_path__ + "img/7b7fb02.webp";